import {
  Wrench,
  Zap,
  LayoutPanelLeft,
  Lightbulb,
  Bell,
  Wind,
  Search,
  Siren,
} from "lucide-react";

export const PHONE = "+39 388 836 3831";
export const PHONE_TEL = "+393888363831";
export const WA_NUMBER = "393888363831";
export const WA_TEXT =
  "Salve ELETTRIKPRO, ho bisogno di un intervento elettrico. Vorrei ricevere informazioni.";

export const waLink = (text = WA_TEXT) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHw0fHxlbGVjdHJpY2lhbiUyMHdvcmtpbmclMjBjbG9zZSUyMHVwfGVufDB8fHx8MTc4NDI5Mzk4Mnww&ixlib=rb-4.1.0&q=85",
  panel:
    "https://images.unsplash.com/photo-1635335874521-7987db781153?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxlbGVjdHJpY2FsJTIwcGFuZWwlMjBtb2Rlcm58ZW58MHx8fHwxNzg0MjkzOTgyfDA&ixlib=rb-4.1.0&q=85",
  testing:
    "https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmclMjBjbG9zZSUyMHVwfGVufDB8fHx8MTc4NDI5Mzk4Mnww&ixlib=rb-4.1.0&q=85",
  naples:
    "https://images.unsplash.com/photo-1707177614710-4d35764f7340?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxuYXBsZXMlMjBpdGFseSUyMGNpdHlzY2FwZXxlbnwwfHx8fDE3ODQyOTM5ODF8MA&ixlib=rb-4.1.0&q=85",
};

export const NAV = [
  { label: "Home", href: "#home" },
  { label: "Servizi", href: "#servizi" },
  { label: "Recensioni", href: "#recensioni" },
  { label: "Chi siamo", href: "#chi-siamo" },
  { label: "Contatti", href: "#contatti" },
];

export const SERVICES = [
  {
    icon: Wrench,
    title: "Riparazioni elettriche",
    desc: "Risoluzione guasti, corto circuiti e problemi all'impianto.",
  },
  {
    icon: Zap,
    title: "Impianti elettrici civili",
    desc: "Installazione e manutenzione impianti per abitazioni.",
  },
  {
    icon: LayoutPanelLeft,
    title: "Quadri elettrici",
    desc: "Controllo, sostituzione e aggiornamento quadri elettrici.",
  },
  {
    icon: Lightbulb,
    title: "Prese, interruttori e illuminazione",
    desc: "Installazione punti luce, lampade, prese e sistemi LED.",
  },
  {
    icon: Bell,
    title: "Citofoni e videocitofoni",
    desc: "Montaggio e riparazione sistemi citofonici.",
  },
  {
    icon: Wind,
    title: "Climatizzazione",
    desc: "Pulizia split e manutenzione climatizzatori.",
  },
  {
    icon: Search,
    title: "Diagnosi guasti",
    desc: "Ricerca precisa del problema e intervento rapido.",
  },
  {
    icon: Siren,
    title: "Pronto intervento elettrico",
    desc: "Assistenza urgente per problemi elettrici, 24 ore su 24.",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Esperienza e competenza",
    desc: "Anni di interventi sul campo per risolvere ogni problema elettrico con sicurezza e precisione.",
  },
  {
    n: "02",
    title: "Interventi veloci",
    desc: "Disponibilità pomeridiana e serale, con pronto intervento attivo 24 ore su 24 a Napoli e provincia.",
  },
  {
    n: "03",
    title: "Lavori puliti e ordinati",
    desc: "Massima cura del dettaglio e rispetto degli spazi: al termine trovi tutto in ordine.",
  },
  {
    n: "04",
    title: "Trasparenza totale",
    desc: "Soluzioni efficaci senza perdite di tempo e preventivi chiari, senza sorprese.",
  },
];

export const AREAS = [
  "Napoli",
  "San Giorgio a Cremano",
  "Portici",
  "Ercolano",
  "Torre del Greco",
  "Casoria",
  "Afragola",
  "Pozzuoli",
  "Comuni della provincia di Napoli",
];

export const BADGES = [
  { icon: "star", label: "4,8/5 recensioni Google" },
  { icon: "zap", label: "Interventi rapidi" },
  { icon: "clock", label: "Disponibile 24 ore su 24" },
  { icon: "check", label: "Professionista qualificato" },
];
